
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(7(18555|36219|61549)|205418|254582|375663|469357|472399|601730|640433|844176|949519)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
